import clsx from "clsx";
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Modal, PlusIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { get } from "lodash";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import GIBDDUploadFileForm from "~/components/Forms/GIBDDUploadFileForm";
import ImportSRRTargetFileForm from "~/components/Forms/ImportSRRTargetFileForm";
import ImportSRRUploadFileForm from "~/components/Forms/ImportSRRUploadFileForm";
import SRRReportForm from "~/components/Forms/SRRReportForm";
import Preloader from "~/components/Preloader";
import Table from "~/components/Table";
import ReportNSByAverageCarAgeTable from "~/pages/SRR/ReportNSByAverageCarAgeTable";
import ReportReturnLoyaltyServiceTable from "~/pages/SRR/ReportReturnLoyaltyServiceTable";
import requestTable from "~/pages/SRR/requestTable";
import Wrapper from "~/shared/ui/Wrapper";
import useVersionContextSpecificSet from "~/versionControl/hooks/useVersionContextSpecificSet";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { getNumberDayMonthYear } from "~/libs/getDateOptions";
import {
  getCustomTableHeaderForSRR,
  getSrrTitleTOMonthControl,
} from "~/pages/SRR/lib";
import { IGroupSrr } from "~/pages/SRR/model/types";
import {
  customHeaderByClient,
  customHeaderByClientCarSale,
  customHeaderByOldClients,
  customHeaderByReportReturnCarServiceByDealer,
  customHeaderByReportReturnSRR3ByCar,
  customHeaderByReportReturnSRR3ByDealer,
  customHeaderByReportReturnSRR3ForPayments,
  customHeaderByReportReturnSRR5ByDealer,
  customHeaderByTOFriendOrFoeByPeriodByCarFamily,
  customHeaderByTOFriendOrFoeBySalesPeriod,
  customHeaderByTOMonthOfControlCarFamilyRegion,
  customHeaderByTOMonthOfControlFriendOrFoe,
  customHeaderByTOMonthOfControlFriendOrFoeByCarFamily,
  customHeaderByTOMonthOfControlMine,
  customHeaderByTOOwnBySalesPeriod,
  customHeaderByWarmClients,
  customHeaderByWarrantyRepairBySalesPeriod,
  customHeaderByWarrantyRepairMonthOfControl,
  customHeaderConsultant,
  customHeaderForNS,
  customHeaderForUVIN,
  getCustomTableBody,
} from "~/pages/SRR/utils/getCustomTable";
import { getNameColumnChildren } from "~/pages/SRR/utils/getNameColumnChildren";
import { getTableHeaders } from "~/pages/SRR/utils/getTableHeaders";
import { usePermissions } from "~/shared/context/PermissionContext";
import { filterOptionByLabel } from "~/shared/lib/filterHelpers";
import { Select } from "~/shared/ui/Select";

import {
  ARR_REPORT,
  GIBDD_TITLE,
  MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE,
  NS_TITLE,
  SRR_GO,
  SRR_PERMISSION_MAP,
  SRR_TITLE,
  SRR_TITLE_TO_MONTH_CONTROL,
  SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD,
  SRR_TO,
  SRR3_TITLE,
  SRR5_TITLE,
  TABLE_REPORT_NO_GROUP,
  UVIN_TITLE,
} from "./options";

import s from "./SRR.less";

const SRR = () => {
  // VERSION_CONTROL_CAMERA_CFG
  const reportsLimitation = get(
    useVersionContextSpecificSet(),
    "page.srr.reportsLimitation",
    [],
  );
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { t } = useTranslation();
  // Открытие/закрытие модалок — через replace, чтобы не плодить историю браузера
  const setDataReplace = useSetLocationData(true);
  const { openModal } = useGetLocationData();
  const [tableRowsSort, setTableRowsSort] = useState([]);
  const [searchTextForSelect, setSearchTextForSelect] = useState();
  const history = useHistory();
  const changeRef = useRef<string>(null);

  const dateCopy = new Date();
  dateCopy.setFullYear(new Date().getFullYear() - 1);

  const filteredSRR_TITLE = useMemo(
    () =>
      SRR_TITLE.filter((item) => hasPermission(SRR_PERMISSION_MAP[item.value])),
    [hasPermission],
  );

  const [reportConfigData, setReportConfigData] = useState({
    groupReport: { value: "Dealer", label: t("srr.Dealers") },
    method: { value: "limit", label: "По сроку эксплуатации" },
    numberTO: [SRR_TO[1], SRR_TO[2], SRR_TO[3], SRR_TO[4], SRR_TO[5]],
    numberTOOne: SRR_TO[1],
    numberGO: [SRR_GO[0], SRR_GO[1], SRR_GO[2]],
    salePeriod: { label: 3, value: 3 },
    CarModel: [],
    monthControl: new Date(),
    salePeriodEnd: new Date(),
    salePeriodStart: dateCopy,
  });

  const openAddModal = () => {
    history.push(`/srr/gibdd`);
  };
  const handleCloseModal = () => {
    setDataReplace("openModal", "", "fileId", "");
  };

  const selectYearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const result = [];
    for (let i = currentYear; i > currentYear - 10; i--) {
      result.push(i);
    }
    return result;
  }, []);

  const isAdd = openModal === "Add";
  const isAddImport =
    openModal === "addFileCreditData" || openModal === "addFileCarPlatform";
  const isAddImportTarget = openModal === "addFileTarget";

  const [groupSrr, setGroupSrr] = useState<IGroupSrr>({
    gorup: "",
    arrTO: [],
    arrGO: [],
    selectCheked: "",
    monthControl: "",
    bonus: undefined,
  });
  const getDefaultSrrTitle = useCallback(() => {
    const first = filteredSRR_TITLE[0];
    if (!first) return null;

    switch (first.value) {
      case "TOMonthOfControl":
        return SRR_TITLE_TO_MONTH_CONTROL[0];
      case "TOBySalesPeriod":
        return SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD[0];
      case "SRR3":
        return SRR3_TITLE[0];
      case "SRR5":
        return SRR5_TITLE[0];
      case "RegistrationOfTrafficPolice":
        return GIBDD_TITLE[0];
      case "reportReturnOfVehiclesForMaintenance":
        return UVIN_TITLE[0];
      case "AverageDailyMileageReport":
        return NS_TITLE[0];
      case "1c-ManagementManufacturingEnterprise":
        return MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE[0];
      default:
        return null;
    }
  }, [filteredSRR_TITLE]);
  const { control, watch, setValue } = useForm({
    defaultValues: {
      srrTitle: SRR_TITLE[0],
      srrTitleTOMonthControl: SRR_TITLE_TO_MONTH_CONTROL[0],
      Year: { label: selectYearOptions[0], value: selectYearOptions[0] },
      Quarter: { label: 1, value: 1 },
      SelectReport: {
        value: "reportYear",
        label: t("regMen.reportYear"),
      },
    },
  });

  const [defaultsSet, setDefaultsSet] = useState(false);
  useEffect(() => {
    if (loadingPermissions || defaultsSet) return;

    const defaultSrrTitle = filteredSRR_TITLE[0] || SRR_TITLE[0];
    const defaultSrrTitleTOMonthControl =
      getDefaultSrrTitle() || SRR_TITLE_TO_MONTH_CONTROL[0];

    setValue("srrTitle", defaultSrrTitle);
    setValue("srrTitleTOMonthControl", defaultSrrTitleTOMonthControl);
    setDefaultsSet(true);
  }, [
    loadingPermissions,
    defaultsSet,
    filteredSRR_TITLE,
    getDefaultSrrTitle,
    setValue,
  ]);

  const isSRRTitle = watch("srrTitle");
  const isSRRTitleTOMonthControl = watch("srrTitleTOMonthControl");

  if (
    changeRef.current !==
    String(isSRRTitle?.value + isSRRTitleTOMonthControl?.value)
  ) {
    changeRef.current = String(
      isSRRTitle?.value + isSRRTitleTOMonthControl?.value,
    );
    setTableRowsSort([]);
  }

  const { tableReport, dataReport, loading, clearTableReport, refetch } =
    requestTable();

  const valueReport = ARR_REPORT.includes(isSRRTitle?.["value"])
    ? isSRRTitleTOMonthControl?.["value"]
    : isSRRTitle?.["value"];

  const groupNameSrr = groupSrr["group"]
    ? groupSrr["group"] === "fo"
      ? "FO"
      : groupSrr["group"]
    : undefined;

  const tableRows = useMemo(() => {
    return tableReport[groupNameSrr] && tableReport[groupNameSrr].length > 0
      ? tableReport[groupNameSrr]
      : TABLE_REPORT_NO_GROUP.includes(valueReport)
        ? tableReport
        : [];
  }, [tableReport, loading, refetch, groupNameSrr, valueReport]);

  const nameColumnChildren = useMemo(
    () => getNameColumnChildren(groupSrr["selectCheked"], groupSrr["arrTO"]),
    [groupSrr],
  );
  const [optionsTable, optionsTableChildren, arrTableRowsPeriod] = useMemo(
    () =>
      getTableHeaders(
        valueReport,
        tableRows,
        groupSrr,
        nameColumnChildren,
        reportConfigData,
      ),
    [valueReport, tableRows, groupSrr, nameColumnChildren, reportConfigData],
  );

  const onOpenModal = useCallback(() => {
    setDataReplace("openModal", "Excel");
  }, [setDataReplace]);
  const onOpenModalFileCredit = () => {
    setDataReplace("openModal", "addFileCreditData");
  };
  const onOpenModalFilePlatform = () => {
    setDataReplace("openModal", "addFileCarPlatform");
  };

  useEffect(() => {
    if (isSRRTitle?.value) {
      setValue("srrTitleTOMonthControl", getSrrTitleTOMonthControl(isSRRTitle));
    }
  }, [isSRRTitle, setValue]);

  const customTableBody = useMemo(
    () => getCustomTableBody(valueReport),
    [valueReport],
  );

  const customHeaders = {
    consultant: customHeaderConsultant,
    ReportReturnLoyaltyServiceByDealer: customHeaderForUVIN,
    ReportNSByDealer: customHeaderForNS,
    ReportNSByClient: customHeaderByClient,
    ReportNSByWarmClients: customHeaderByWarmClients,
    ReportNSByOldClients: customHeaderByOldClients,
    ReportNSByClientCarSale: customHeaderByClientCarSale,
    TOMonthOfControlMine: customHeaderByTOMonthOfControlMine,
    TOOwnBySalesPeriod: customHeaderByTOOwnBySalesPeriod,
    warrantyRepairMonthOfControl: customHeaderByWarrantyRepairMonthOfControl,
    TOMonthOfControlFriendOrFoe: customHeaderByTOMonthOfControlFriendOrFoe,
    TOMonthOfControlFriendOrFoeByCarFamily:
      customHeaderByTOMonthOfControlFriendOrFoeByCarFamily,
    TOFriendOrFoeBySalesPeriod: customHeaderByTOFriendOrFoeBySalesPeriod,
    TOFriendOrFoeByPeriodByCarFamily:
      customHeaderByTOFriendOrFoeByPeriodByCarFamily,
    warrantyRepairBySalesPeriod: customHeaderByWarrantyRepairBySalesPeriod,
    TOMonthOfControlCarFamilyRegion:
      customHeaderByTOMonthOfControlCarFamilyRegion,
    ReportReturnCarServiceByDealer:
      customHeaderByReportReturnCarServiceByDealer,
    ReportReturnSRR3ForPayments: customHeaderByReportReturnSRR3ForPayments,
    ReportReturnSRR5ForPayments: customHeaderByReportReturnSRR3ForPayments,
    ReportReturnSRR3ByCar: customHeaderByReportReturnSRR3ByCar,
    ReportReturnSRR5ByCar: customHeaderByReportReturnSRR3ByCar,
    ReportReturnSRR3ByDealer: customHeaderByReportReturnSRR3ByDealer,
    ReportReturnSRR5ByDealer: customHeaderByReportReturnSRR5ByDealer,
  };
  const rowTO = ["TO1", "TO2", "TO3", "monthControl"];
  const rowTO5 = ["TO1", "TO2", "TO3", "TO4", "TO5", "monthControl"];
  const customHeaderMemo = useMemo(
    () =>
      getCustomTableHeaderForSRR(
        valueReport,
        customHeaders,
        tableRowsSort,
        groupSrr,
        rowTO,
        rowTO5,
        t,
      ),
    [valueReport, customHeaders, tableRowsSort, groupSrr, t],
  );

  useEffect(() => {
    if (!!groupSrr.arrTO.length && tableRows.length) {
      const getSortRows = tableRows.map((row) => {
        const clearTOFromRow = Object.keys(row).reduce((acc, key) => {
          if (key.search(/TO[0-9]/) !== -1) {
            return acc;
          } else {
            return { ...acc, [key]: row[key] };
          }
        }, {});
        return {
          ...groupSrr.arrTO.reduce((acc, key) => {
            return { ...acc, [key]: row[key] };
          }, {}),
          ...clearTOFromRow,
        };
      });

      setTableRowsSort(getSortRows);
    } else {
      setTableRowsSort(tableRows);
    }
  }, [tableRows, groupSrr.arrTO]);

  useEffect(() => {
    setTableRowsSort([]);
  }, [isSRRTitle?.value, isSRRTitleTOMonthControl?.value]);

  // VERSION_CONTROL_CAMERA_CFG
  // Убрать фильтр при очистке VCS
  const srrTitleOptions = useMemo(
    () =>
      filteredSRR_TITLE.filter(
        (title) => !reportsLimitation.includes(title.label),
      ),
    [filteredSRR_TITLE, reportsLimitation],
  );

  return (
    <Wrapper.Content
      title="SRR"
      controlComponent={
        <Flex gap={10}>
          {valueReport === "ReportNSByWarmClients" && (
            <>
              <Button
                size="middle"
                color="primary"
                icon={<PlusIcon size={16} />}
                onClick={onOpenModalFileCredit}
              >
                {t("srr.creditData")}
              </Button>
              <Button
                size="middle"
                color="primary"
                icon={<PlusIcon size={16} />}
                onClick={onOpenModalFilePlatform}
              >
                {t("srr.Platform")}
              </Button>
            </>
          )}
        </Flex>
      }
    >
      <div className={s.formReport}>
        <form>
          <div className={s.wrapperSSRSelect}>
            {/* VERSION_CONTROL_SRR_CFG */}
            {/* В Select фильтрованный SRR_TITLE */}
            <Controller
              name="srrTitle"
              control={control}
              render={({ value, onChange }) => (
                <Select
                  value={value}
                  labelInValue
                  showSearch
                  filterOption={filterOptionByLabel}
                  options={srrTitleOptions}
                  className={s.width_select}
                  onChange={(nextValue) => {
                    onChange(nextValue);
                    clearTableReport();
                  }}
                />
              )}
            />
            {ARR_REPORT.includes(isSRRTitle?.["value"]) && (
              <Controller
                name="srrTitleTOMonthControl"
                control={control}
                render={({ value, onChange }) => (
                  <Select
                    value={value}
                    labelInValue
                    showSearch
                    filterOption={filterOptionByLabel}
                    options={
                      isSRRTitle["value"] === "TOMonthOfControl"
                        ? SRR_TITLE_TO_MONTH_CONTROL
                        : isSRRTitle["value"] === "SRR3"
                          ? SRR3_TITLE
                          : isSRRTitle["value"] === "SRR5"
                            ? SRR5_TITLE
                            : isSRRTitle["value"] ===
                                "RegistrationOfTrafficPolice"
                              ? GIBDD_TITLE
                              : isSRRTitle["value"] ===
                                  "reportReturnOfVehiclesForMaintenance"
                                ? UVIN_TITLE
                                : isSRRTitle["value"] ===
                                    "AverageDailyMileageReport"
                                  ? NS_TITLE
                                  : isSRRTitle["value"] ===
                                      "1c-ManagementManufacturingEnterprise"
                                    ? MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE
                                    : SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD
                    }
                    className={s.width_select}
                    onChange={(nextValue) => {
                      onChange(nextValue);
                      clearTableReport();
                    }}
                  />
                )}
              />
            )}
            {isSRRTitle?.["value"] === "RegistrationOfTrafficPolice" &&
              hasPermission("srr.gibdd.set") && (
                <Button
                  size="middle"
                  color="primary"
                  icon={<PlusIcon size={16} />}
                  onClick={openAddModal}
                >
                  {t("srr.BtnGibdd")}
                </Button>
              )}
            <Button size="middle" color="success" onClick={onOpenModal}>
              {t("srr.parameters")}
            </Button>
          </div>
        </form>
      </div>

      {loading ? (
        <Preloader />
      ) : valueReport === "ReportReturnLoyaltyService" ? (
        <ReportReturnLoyaltyServiceTable
          items={tableRows}
          reportConfigData={reportConfigData}
        />
      ) : valueReport === "ReportNSByAverageCarAge" ? (
        <ReportNSByAverageCarAgeTable
          items={tableRows}
          reportConfigData={reportConfigData}
        />
      ) : (
        (typeof (tableRowsSort as any) === "object" &&
        !Array.isArray(tableRowsSort as any)
          ? (tableRowsSort as any).hasOwnProperty("data")
            ? (tableRowsSort as any).data
            : []
          : tableRowsSort
        ).length > 0 && (
          <TableSRR
            optionsTable={optionsTable}
            optionsTableChildren={optionsTableChildren}
            arrTableRowsPeriod={arrTableRowsPeriod}
            tableRows={
              typeof (tableRowsSort as any) === "object" &&
              !Array.isArray(tableRowsSort as any)
                ? (tableRowsSort as any).hasOwnProperty("data")
                  ? (tableRowsSort as any).data
                  : []
                : tableRowsSort
            }
            groupNameSrr={groupNameSrr}
            valueReport={valueReport}
            nameColumnChildren={nameColumnChildren}
            groupSrr={groupSrr}
            customHeaderMemo={customHeaderMemo}
            customTableBody={customTableBody}
            searchTextForSelect={searchTextForSelect}
          />
        )
      )}
      <Modal
        open={openModal === "Excel"}
        title={`Отчет ${
          ARR_REPORT.includes(isSRRTitle?.["value"])
            ? t(`srr.${isSRRTitleTOMonthControl?.["value"]}`)
            : t(`srr.${isSRRTitle?.["value"]}`)
        }`}
        onCancel={handleCloseModal}
        closable
        centered
        footer={false}
        className={s.footer}
      >
        <SRRReportForm
          firstSelectVal={isSRRTitle?.value}
          reportSelect={valueReport}
          setSearchTextForSelect={setSearchTextForSelect}
          clearTableReport={clearTableReport}
          onSumbitTable={dataReport(valueReport)}
          setGroupSrr={setGroupSrr}
          reportConfigData={reportConfigData}
          setReportConfigData={setReportConfigData}
          loading={loading}
          refetch={refetch}
        />
      </Modal>

      <Modal
        open={isAdd}
        title={t("pkd.upload_file")}
        onCancel={handleCloseModal}
        closable
        centered
      >
        <GIBDDUploadFileForm setCloseModal={handleCloseModal} />
      </Modal>

      <Modal
        open={isAddImport}
        title={t("pkd.upload_file")}
        onCancel={handleCloseModal}
        closable
        centered
      >
        <ImportSRRUploadFileForm
          report={valueReport}
          setCloseModal={handleCloseModal}
        />
      </Modal>

      <Modal
        open={isAddImportTarget}
        title={t("srr.uploadTarget")}
        onCancel={handleCloseModal}
        closable
        centered
      >
        <ImportSRRTargetFileForm
          report={valueReport}
          setCloseModal={handleCloseModal}
        />
      </Modal>
    </Wrapper.Content>
  );
};

export interface ITableSrr {
  optionsTable: any[];
  optionsTableChildren: any[];
  arrTableRowsPeriod: any[];
  tableRows: any[];
  nameColumnChildren: any[];
  customHeaderMemo: any[];
  customTableBody: any;
  valueReport: string;
  groupNameSrr?: string;
  searchTextForSelect: string;
  groupSrr: IGroupSrr;
}

const TableSRR: FC<ITableSrr> = ({
  optionsTable,
  optionsTableChildren,
  arrTableRowsPeriod,
  tableRows,
  valueReport,
  nameColumnChildren,
  groupSrr,
  groupNameSrr = "",
  customHeaderMemo = [],
  customTableBody,
  searchTextForSelect,
}) => {
  const arrSrrCustom = [
    "ReportReturnLoyaltyServiceByDealer",
    "ReportNSByDealer",
    "ReportNSByClient",
    "ReportNSByConsultant",
    "ReportNSByWarmClients",
    "ReportNSByOldClients",
    "ReportNSByAverageCarAge",
    "ReportNSByClientCarSale",
    "TOMonthOfControlMine",
    "TOOwnBySalesPeriod",
    "warrantyRepairMonthOfControl",
    "TOMonthOfControlFriendOrFoe",
    "TOMonthOfControlFriendOrFoeByCarFamily",
    "TOFriendOrFoeBySalesPeriod",
    "TOFriendOrFoeByPeriodByCarFamily",
    "warrantyRepairBySalesPeriod",
    "TOMonthOfControlCarFamilyRegion",
    "ReportReturnCarServiceByDealer",
    "ReportReturnSRR3ForPayments",
    "ReportReturnSRR5ForPayments",
    "ReportReturnSRR3ByCar",
    "ReportReturnSRR5ByCar",
    "ReportReturnSRR3ByDealer",
    "ReportReturnSRR5ByDealer",
  ];

  return (
    <>
      <Table
        options={optionsTable}
        optionsChildren={optionsTableChildren}
        arrTableRowsPeriod={arrTableRowsPeriod}
        items={tableRows}
        groupNameSrr={groupNameSrr}
        // loading={loading}
        reportSelect={valueReport}
        nameColumnChildren={nameColumnChildren}
        sortable={false}
        groupSrr={groupSrr}
        positionStiki
        type={arrSrrCustom.includes(valueReport) ? "srr-custom" : "srr"}
        customClassName={clsx(s.dealers_table, {})}
        customHeader={customHeaderMemo}
        TableBodyComponent={customTableBody}
        rowValuesDecorator={(item, optionName) => {
          if (optionName === "dateSales")
            return getNumberDayMonthYear({ date: item });
          return item;
        }}
        searchTextForSelect_ONLY_SRR={searchTextForSelect}
      />
    </>
  );
};

export default SRR;
